import { Component } from '@angular/core';

@Component({
  selector: 'app-reset-left-container',
  imports: [],
  templateUrl: './reset-left-container.html',
  styleUrl: './reset-left-container.scss'
})
export class ResetLeftContainer {

}
